import React from "react";
import { Button } from "@mui/material";
import { logout } from "service/api";

const LogoutButton = () => {
  const handleLogout = async () => {
    await logout();
    window.location.reload();
  };

  return (
    <Button
      variant="contained"
      color="error"
      sx={{
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: 9999,
        textTransform: "none",
      }}
      onClick={handleLogout}
    >
      Logout
    </Button>
  );
};

export default LogoutButton;
